import { createContext, useContext, useMemo, useCallback } from "react";
import { useSessionStore } from "../stores/sessionStore";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const { profile, loggedIn, appToken, loginSuccess, logout } =
    useSessionStore();

  // logout แล้วเคลียร์เฉพาะ session store
  const logoutAndClear = useCallback(() => {
    logout();
  }, [logout]);

  const value = useMemo(
    () => ({
      user: profile,
      isAuthenticated: loggedIn,
      token: appToken,

      // ✅ ไม่แยก role / ไม่ใช้ setting / ไม่ใช้ tnId-orgId-brId
      login: (tk, _role, fullUserObj) => {
        const safe = {
          username: fullUserObj?.username ?? fullUserObj?.empUsername ?? null,
          avatar: fullUserObj?.avatar ?? null,
          // ถ้าคุณอยากเก็บ field อื่นจาก API เพิ่ม ก็ใส่เพิ่มได้
          // เช่น id: fullUserObj?.id ?? null,
        };

        loginSuccess(safe, tk || null);
      },

      logout: logoutAndClear,
    }),
    [profile, loggedIn, appToken, loginSuccess, logoutAndClear],
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
